import { Component, NgModule, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxListModule } from 'devextreme-angular/ui/list';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
import { AuthService } from '../../services';
import { UtilitiesService } from '../../services/utilities.service';
import { User } from '../../models/users';
import { Company } from '../../models/companies';

@Component({
  selector: 'app-user-panel',
  templateUrl: 'user-panel.component.html',
  styleUrls: ['./user-panel.component.scss']
})

export class UserPanelComponent {
  userData: any;
  companyData: Company;
  @Input()
  menuItems: any;

  @Input()
  menuMode: string;

  constructor(
    private authService: AuthService,
    private utilitiesServices: UtilitiesService
  ) { }

  async ngOnInit() {
    this.userData = this.utilitiesServices.getUserData();
    this.companyData = this.utilitiesServices.getCompanyData();
    //  console.log(this.companyData);
    // console.log('user data', this.userData);
  }

}

@NgModule({
  imports: [
    DxListModule,
    DxContextMenuModule,
    CommonModule
  ],
  declarations: [UserPanelComponent],
  exports: [UserPanelComponent]
})
export class UserPanelModule { }
